export default {
  reserveBtnText: "下载游戏",
  pageTitle: "《RO仙境传说：世界之旅》玩家共创主题页",
  loginBtn: "请先登录",
  logoutBtn: "[ 退出登录 ]",
  joinActivityText: '已有 <span class="number">${n}</span> 人参加共创活动',
  search: "搜索",
  searchPlaceholder: "请输入创作者名称/关键字",
  filter: "筛选",
  sortBy: "排序依据",
  sortByTime: "最新",
  sortByHot: "热门",
  releaseTime: "发布时间",
  noLimit: "不限",
  oneDay: "一天内",
  oneWeek: "一周内",
  reset: "重置",
  loginTip: "完成登录即可参与内容创作",
  nowLoginBtn: "立即登录",
  home: "回到首页",
  creativeCenter: "作品管理",
  developmentLog: "研发者日志",
  devSectionSubtitle: "写给所有等待RO再次相遇的人",
  feedback: "意见反馈",
  feedbackPopupTitle: "意见反馈提交",
  feedbackAccount: "当前账号：",
  notLoggedIn: "未登录",
  feedbackEmail: "电子邮箱：",
  feedbackEmailPlaceholder: "请输入联系邮箱",
  feedbackCategory: "意见类别：",
  feedbackCategoryPlaceholder: "请选择反馈类别",
  feedbackCat1: "游戏Bug",
  feedbackCat2: "功能建议",
  feedbackCat3: "系统优化建议",
  feedbackCat4: "其他问题",
  feedbackContent: "意见反馈内容：",
  feedbackContentPlaceholder: "请详细描述您的反馈内容",
  feedbackAttachment: "附件上传",
  feedbackAttachmentLimit: "最多上传3个附件",
  feedbackAddAttachment: "添加附件",
  feedbackErrEmail: "请输入电子邮箱",
  feedbackErrCategory: "请选择意见类别",
  feedbackErrContent: "请输入意见反馈内容",
  feedbackErrFileSize: "文件大小不能超过10MB",
  feedbackErrFileType: "仅支持图片(JPG/PNG)和文档(PDF/DOC/DOCX)格式",
  exitConfirmTitle: "提示",
  exitConfirmLine1: "退出后已填写内容无法保存",
  exitConfirmLine2: "是否继续退出？",
  publishTime: "发表时间：",
  selectType: "请选择类型",
  createType1: "时装设计",
  createType2: "头饰设计",
  createType3: `造"梗"活动`,
  createType4: "我的 RO 回忆",
  createType5: "美照分享",
  createType6: "我的波利",
  createType7: "职业分享",
  ugcJoinBtn: '前往参与',
  kolPopupTitle: "KOL申请",
  kolAccount: "当前帐号：",
  kolEmail: "电子邮箱：",
  kolEmailPlaceholder: "请输入联系邮箱",
  kolDiscordId: "Discord User ID：",
  kolDiscordIdPlaceholder: "请输入Discord User ID",
  kolSpecialty: "创作专长：",
  kolSpecialtyPlaceholder: "请选择创作专长",
  kolSpecialty1: "攻略撰写",
  kolSpecialty2: "美术设计",
  kolSpecialty3: "影片制作",
  kolSpecialty4: "其它",
  kolWorkUrl: "过往作品链接：",
  kolWorkUrlPlaceholder: "请输入过往作品的链接地址，多个链接请用逗号分隔",
  kolFollower: "订阅者数量：",
  kolFollowerPlaceholder: "请输入当前订阅者数量",
  kolSubmitBtn: "提交",
  kolErrEmail: "请输入电子邮箱",
  kolErrEmailFormat: "请输入正确的电子邮箱格式",
  kolErrDiscord: "请输入Discord User ID",
  kolErrSpecialty: "请选择创作专长",
  kolErrWorkUrl: "请输入过往作品链接",
  kolErrFollower: "请输入有效的订阅者数量",
  kolSubmitSuccess: "申请提交成功",
  feedbackSuccessTitle: '亲爱的初心者',
  feedbackSuccessContent: '恭喜您已提交成功！',
  kolSubmitFail: "申请提交失败，请稍后重试",
  kolNetworkFail: "申请提交失败，请检查网络连接后重试",
  kolSubtitle: "加入创作者团队",
  kolContent: "在这里你不仅可以和优秀的创作者们交流学习，还能获得专属丰厚好礼喔！快快点击申请吧！",
  kolViewBtn: "前往查看",
  lotterySubTitle: '参与共创活动获得积分，<span class="red">抽取限定虚宝与精美实物周边！</span>',
  drawSubTitle: '部分重磅奖励展示',
  physicalRewardsLabel: '实物奖励：',
  inGameRewardsLabel: '游戏内奖励：',
  myPoints: "我的积分：",
  viewPointDetail: "查看积分明细 >>",
  currentTitle: "目前称号：",
  taskRuleBtn: "活动规则",
  taskBtnFinished: "已完成",
  taskBtnEnded: "已结束",
  taskBtnGo: "立即前往",
  taskDailyLoginTitle: "每日首次登录",
  taskDailyLoginDesc: "每日登录页面（5分）",
  taskReserveTitle: "前往下载游戏",
  taskReserveDesc: "首次完成游戏下载（25分）",
  taskFeedbackTitle: "提交意见反馈",
  taskFeedbackDesc: "每日首次提交反馈（15分）",
  taskRoMemoryTitle: "我的波利投稿",
  taskRoMemoryDesc: "每日首次投稿（25分），每周上限50分",
  taskCostumeTitle: "职业分享投稿",
  taskCostumeDesc: "每日首次投稿（25分），每周上限25分",
  taskPhotoTitle: "美照分享投稿",
  taskPhotoDesc: "每日首次投稿（25分），每周上限50分",
  taskLikeOtherTitle: "为他人作品点赞",
  taskLikeOtherDesc: "每次点赞可获得0.5分，每日上限5分（{n}/5分）",
  taskLikeMyTitle: "作品获得赞",
  taskLikeMyDesc: "获得1个赞可得1分，每周上限200分（{n}/200分）",
  taskFbTitle: "关注Facebook",
  taskFbDesc: "加入官方Facebook（10分）",
  taskDcTitle: "关注Discord",
  taskDcDesc: "关注官方Discord（10分）",
  taskYtbTitle: "关注YouTube",
  taskYtbDesc: "关注官方YouTube（10分）",
  taskLineTitle: "关注LINE",
  taskLineDesc: "关注官方LINE（10分）",
  ugcTabContent6: "黑白的、粉色的、代码组成的……|你心中的波利是什么样子？|快来分享你的波利创作，|让可爱占领米德加尔特！|参与规则：分享自己画的波利|（不限形式，手绘，代码等都可以）",
  ugcTabContent7: "分享你的技能加点与战斗精彩瞬间，|让更多冒险者看到你的职业高光时刻！|参与规则：上传游戏内|任意职业战斗/加点截图",
  ugcTabContent5: "无缝大世界就是最好的摄影棚。|晒出个性穿搭、打卡美景，|记录属于你的米德加尔特精彩瞬间！|参与规则：上传游戏内|服装染色/搭配+风景截图",
  communicationType1: "意见反馈",
  communicationType2: "研发者日志",
  inputTitle: "请填写标题",
  inputContent: "请输入正文",
  uploadImage: "图片编辑",
  uploadImageTip: "支持拖拽排序",
  addImage: "新增",
  creationBtnText: "我要发布",
  publish: "我要发布",
  loading: "加载中",
  publishSuccess: "发表成功，等待审核",
  commonTip: "请稍后再试",
  editSaveTip: "这次编辑是否要保留？",
  saveCancel: "不保留",
  saveConfirm: "保留",
  myCreative: "我的创作",
  deleteTip: "删除这个内容创作？",
  confirmBtn: "确认",
  cancelBtn: "取消",
  submitBtn: "提交",
  tipPopupTitle: "提示",
  loginPopupTitle: "提示",
  scoreDetailTitle: "我的积分",
  lotterySuccTitle: "恭喜获得",
  physicalAwardTitle: "填写收货信息",
  physicalCheckTitle: "提示",
  vtCodeTitle: "已领取",
  realNameLabel: "真实姓名",
  phoneLabel: "联系手机",
  areaCodeLabel: "区号",
  addressLabel: "收货地址",
  countryLabel: "国家/地区",
  postalCodeLabel: "邮政编码",
  confirmShippingTip: "确认收货信息后无法更改<br />是否确认？",
  submitSuccessTip: "提交成功",
  scoreItemLabel: "项目",
  scoreChangeLabel: "积分变化",
  scoreTimeLabel: "时间",
  lotteryDrawLabel: "积分抽奖",
  auditResultNotice: "审核结果通知",
  auditResultContent:
    "亲爱的玩家<br/><br/>您于${time} 发表标题为【${title}】的创作内容审核未通过，请修改后重新上传",
  auditReason: "未通过原因：",
  auditTime: "审核时间：",
  emptyNotice: "暂无更多内容",
  emptyWorks: "一起来参与共创吧！",
  viewImage: "点击可查看原图",
  createPopupTitle: "发布创作",
  gameName: "RO仙境传说：世界之旅",
  gameType: "首款大世界RO",
  loadingMore: "滑动加载更多",
  noMoreData: "暂无更多内容",
  auditPass: "已发布",
  auditFail: "未通过",
  auditState: "审核中",
  ugcRuleRules: `《Ragnarok: The New World》UGC投稿活动规则

一、投稿内容要求
1. 所有投稿内容须与《Ragnarok: The New World》相关，且必须为投稿者原创作品。严禁抄袭、盗用、搬运或未经授权使用他人素材。
2. 投稿内容需符合对应赛道主题及活动要求。
3. 如投稿内容包含第三方素材、音乐、图片或其他受版权保护的内容，投稿者须确保已获得合法授权；因版权问题产生的纠纷与责任由投稿者自行承担。
4. 官方有权对所有投稿内容进行审核。对于违规、不当、低质量、与活动无关或不符合活动要求的内容，官方有权拒绝展示、取消活动资格，并不发放相关积分或奖励。

二、作品展示与互动
1. 审核通过的作品将在活动页「作品墙」进行展示。
2. 玩家可对展示作品进行浏览、点赞及互动。
3. 官方有权根据活动运营需要，对作品展示顺序、推荐内容及展示形式进行调整。

三、作品授权与使用说明
1. 投稿成功后，即视为投稿者同意授予《Ragnarok: The New World》官方全球范围内、永久、不可撤销、非独占且免版税的使用授权。
2. 官方可将投稿内容用于游戏内外、官方网站、社交媒体平台、市场宣传、活动推广、周边制作及相关衍生内容。
3. 为满足宣传及运营需要，官方有权对投稿内容进行必要的编辑、优化、改编或重新制作。
4. 投稿者仍保留其原创作品的版权及署名权。

四、活动参与与奖励说明
1. 请玩家在规定时间内完成活动相关操作，包括但不限于投稿、积分获取与兑换、奖励领取及收件信息填写等。
2. 若玩家未在指定期限内完成相关操作，将视为自动放弃对应资格、积分或奖励。
3. 对于逾期未领取的奖励、未使用的积分或未完成的信息提交，官方不再另行补发或恢复。
4. 因玩家填写错误、不完整、失效或未及时更新个人信息，导致无法参与活动或领取奖励的，官方不承担相关责任。
5. 若因账号异常、账号被盗、设备问题、网络问题或违反游戏规则导致账号被限制或封禁，从而影响活动参与或奖励领取，官方不承担相关责任；活动期间若账号被封禁，其未使用积分及未领取奖励将自动失效。

五、反作弊与违规处理
官方将严密监控活动参与行为，一旦监测到以下违规行为，将立即采取包括但不限于封锁涉事账号、撤销其所有活动资格、追回已发放之奖励（含已使用虚拟道具）及追究法律责任之权利：
1. 使用任何方式进行批量注册小号（同人、同设备、同IP多账号等）参与活动。
2. 利用程序漏洞、非官方提供之工具或任何非正常手段刷取积分。
3. 使用非法第三方软件、外挂或辅助工具干扰活动。
4. 任何形式的自点赞、互刷赞、买赞等异常或虚假互动行为。
5. 提供虚假个人信息或盗用他人信息。
6. 其他经官方认定违反活动公平性、损害游戏环境之行为。

六、不可抗力条款
如遇以下不可归责于官方之不可抗力因素（包含但不限于：政府政策法令变更、气象灾害、疫情、战争等），官方保留调整活动时间的权利：视情况延长、缩短或暂停活动，并将于游戏官网或粉丝专页至少提前24小时公告。如遇突发不可抗力（包含但不限于：重大服务器故障、黑客攻击等），无法提前公告时，官方承诺于第一时间尽快公告。

七、免责声明
1. 参与本活动即视为玩家已阅读、理解并同意本活动全部规则与说明。
2. 未成年人或限制民事行为能力人，应在法定监护人同意后参与本活动。
3. 所有活动相关记录，包括积分获取、积分使用、抽奖结果及奖励发放等，均以官方系统记录为最终依据。

※ 《Ragnarok: The New World》官方保留本活动最终解释权，并有权在法律允许范围内，根据实际情况对活动内容、规则及奖励进行调整或补充，相关内容以官方公告为准。`,
  rulePopupTitle: "活动规则",
  overTenTips: "今天发布已经超过10篇啦，明天再来吧～",
  rulePopupContent: ``,
  backText: "返回UGC创作",
  21000: "未登录",
  21001: "获取上传地址失败",
  21002: "完成文件合并失败",
  21003: "切片数量无效",
  21004: "上传ID或上传路径不能为空",
  21005: "参数错误",
  21006: "提交内容失败",
  21007: "点赞失败",
  21008: "清除小红点失败",
  21010: "今天发布太多啦，明天再来吧",
  21011: "今天提交次数太多，明天再来吧～",
  21013: "今天提交次数太多，明天再来吧～",
  21014: "邮箱格式不正确",
  21018: "积分不足",
  21019: "抽奖失败",
  21022: "活动未结束",
  21023: "无可领取的实物奖励",
  21024: "领取实物奖励失败",
  21025: "提交的资料过长",
  21026: "还有剩余积分可抽奖",
  21027: "没有可领取的虚拟奖励",
  21028: "奖励记录不存在",
  21029: "奖励不属于当前用户",
  21030: "奖励类型不是虚拟奖励",
  21031: "奖励未领取",
  viewMyRewardsBtn: "查看我的奖品",
  claimRewardsBtn: "领取奖励",
  claimVirtualBtn: "领取虚拟奖励",
  claimPhysicalBtn: "领取实物奖励",
  myRewardsTitle: "我的奖品",
  prizeNameLabel: "奖品名称",
  prizeQtyLabel: "奖品数量",
  obtainTimeLabel: "获得时间",
  currentStatusLabel: "当前状态",
  viewGiftCodeBtn: "查看礼包码",
  claimTips: "* 请在游戏公测期间前往本页面领取",
  congratulations: "恭喜获得",
  giftCodeLabel: "礼包码：",
  copyBtn: "复制",
  copiedBtn: "已复制",
  useGiftCodeTips: "请至游戏内使用已领取的礼包码",
  unclaimedStatus: "待领取",
  claimedStatus: "已领取",
  oneDraw: "单次抽奖",
  tenDraw: "10次抽奖",
  lotteryPointCost: "每次抽奖消耗：25积分",
  spendPointsFirst: "请先消耗积分，完成抽奖后即可领奖噢~",
  claimVirtualRewardSuccess: "请至【我的奖品】页面查看礼包码",
  submitting: "提交中...",
  submitSuccess: "提交成功！",
  submitFailed: "提交失败，请重试",
  imageRequired: "必须上传图片哦",
  footerProvision: `
    <ol>
        <li>本游戏内容涉及暴力(武侠动作)、恋爱交友、角色穿着凸显胸、臂之服节</li>
        <li>本游戏部分内容需另行支付费用</li>
        <li>请避免沉迷游戏</li>
    </ol>
  `,
  taskRulePopupTitle: "规则说明",
  taskRuleRules:`《Ragnarok: The New World》积分抽奖活动规则

一、活动时间
2026年7月17日 00:00 - 2026/8/24 23:59（UTC+7）

二、积分获取途径与规则
1. 每日首次登录：5分/次，每日限计1次。
2. 事前预约：25分/次，仅计入1次首次预约。
3. 加入官方社群账号，包括Facebook、Discord、Line、YouTube，加入一个平台的官方账号可获得10分，每个平台限计1次首次加入。
4. 参与"意见反馈提交"：15分/次，不限制上传次数，每天仅首次上传可获得积分。
5. 参与"我的波利"活动投稿：必须投稿图片，25分/次，每天首次投稿可得分，限制每周最多2次投稿。
6. 参与"职业分享"活动投稿：必须投稿图片，25分/次，每天首次投稿可得分，限制每周最多1次投稿。
7. 参与"美照分享"活动投稿：必须投稿图片，25分/次，每天首次投稿可得分，限制每周最多2次投稿。
8. 为他人的作品点赞：0.5分/赞，每个作品仅计一次有效点赞，取消后再点赞不可再次得分，每日仅限前10个有效点赞可获得积分。
9. 作品获得他人点赞：1分/赞，为防止恶意刷分，单一账号每周通过此途径获得的积分上限为200个有效点赞（即200分）。
10. 点赞账号需为活跃有效账号，官方系统将侦测异常点赞模式，官方保留因作弊行为（包含但不限于自点赞、互刷群组等）取消异常积分的权利。
11. 上述每日刷新参与次数的活动均于每日凌晨00:00刷新，每周参与次数的活动均于每周一00:00刷新。

三、积分抽奖规则
1. 玩家于活动期间参与共创活动获得积分，每25积分可兑换一次抽奖机会，每250积分可进行一次十连抽奖。积分仅限于抽奖活动期间内使用，逾期失效。
2. 奖励及概率如下：
- 未中奖 （20%）
- 游戏道具 定制头饰【黑猫耳朵】*1（2%）
- 游戏道具 定制头像框【共创企划家】*1（3%）
- 游戏道具 定制称号【向企划抛出枯树枝】*1（6%）
- 游戏道具 卡普拉盲盒*1（10%）
- 游戏道具 绑定zeny*3000（12%）
- 游戏道具 冒险币*10000（30%）
- 实物周边 BABYMONSTER联名限定小卡（全套）*1（1%）
- 实物周边 限定玩偶*1（3%）
- 实物周边 收藏卡牌*1（4%）
- 实物周边 联名双肩包*1（4%）
- 实物周边 冒险野餐垫*1（5%）

四、奖品领取相关规则
1. 奖励领取功能将在活动结束后开放。
2. 虚拟奖励领取规则：
   1）用户在活动中抽到的虚拟奖励，可点击"查看我的奖品"按钮统一查看。
   2）活动结束后，用户可在本页面领取所获奖品对应的礼包兑换码，并前往游戏内兑换。
3. 实物奖品领取规则：
   1）中奖玩家必须于活动结束后的30个工作日内，在活动页面填写完整且正确的收件信息（拒绝提供或逾期提供，视为自动放弃领奖资格）。
   2）收件信息填写要求：①真实姓名 ②有效手机号码 ③详细至门牌号的有效收件地址④邮政编码。
*请玩家务必仔细核对信息正确性。因信息填写错误、不全或收件人无法联系导致物流失败、奖品遗失或退回者，官方恕不补发、不赔偿，亦不承担任何责任。您所提供的个人资料，仅供本次活动奖品寄送及相关行政作业之用，主办单位将依相关法令规定善尽保密责任。
   3）实物奖品发放时间：预计于活动结束后30至60个工作天内陆续发货完毕，请耐心等候。
   4）请特别注意，本活动仅面向泰国、柬埔寨、东帝汶、印度尼西亚、老挝、马来西亚、缅甸、菲律宾、新加坡。中奖玩家填写的收件地址不能超出上述区域范围，否则视为放弃实物奖品。

五、玩家责任与弃权条款
1. 请玩家密切关注本活动规则及各项时限（包含活动期间、积分获取与兑换期间、地址填写截止日、虚拟奖品领取期间等），若玩家未于官方指定的规则时间内参与活动、兑换抽奖机会、填写收件地址或领取虚拟奖品，一律视为玩家自动放弃相关权益。
2. 因前述弃权行为导致之所有损失（包含但不限于积分失效、奖品无法领取等），概由玩家自行承担，官方无须给予任何形式之补偿或恢复。

六、作品版权与使用说明
您于投稿时即同意授予游戏官方一项全球范围内、永久、不可撤回且免权利金之授权，用于游戏内外及相关营销、宣传、改作及衍生利用。官方有权对您的投稿内容进行必要的修改、优化、制作、重制，并应用于游戏内、游戏周边商品、市场推广等相关活动中。

七、反作弊与违规处理
官方将严密监控活动参与行为，一旦监测到以下违规行为，将立即采取包括但不限于封锁涉事账号、撤销其所有活动资格、追回已发放之奖励（含已使用虚拟道具）及追究法律责任之权利：
1. 使用任何方式进行批量注册小号（同人、同设备、同IP多账号等）参与活动。
2. 利用程序漏洞、非官方提供之工具或任何非正常手段刷取积分。
3. 使用非法第三方软件、外挂或辅助工具干扰活动。
4. 任何形式的自点赞、互刷赞、买赞等异常或虚假互动行为。
5. 提供虚假个人信息或盗用他人信息。
6. 其他经官方认定违反活动公平性、损害游戏环境之行为。

八、不可抗力条款
如遇以下不可归责于官方之不可抗力因素（包含但不限于：政府政策法令变更、气象灾害、疫情、战争等），官方保留调整活动时间的权利：视情况延长、缩短或暂停活动，并将于游戏官网或粉丝专页至少提前24小时公告。如遇突发不可抗力（包含但不限于：重大服务器故障、黑客攻击等），无法提前公告时，官方承诺于第一时间尽快公告。

九、免责声明
参与本活动即表示您已充分阅读、理解并同意以下事项：
1. 若您为未成年人或限制行为能力人，您已经得到法定代理人同意后才参加本活动。
2. 时效弃权：未在官方指定之各项规则时间内（积分兑换期、地址填写截止日、虚拟奖品领取期等）完成必要操作，一律视为自动放弃相关权益。
3. 信息错误责任：因玩家提供之个人信息（包含但不限于收件信息、账号信息）错误、不实、失效或未及时更新，导致无法获得积分、无法参与抽奖、奖品无法送达、虚拟奖品无法发放或任何损失，官方概不负责。
4. 账号安全与状态责任：因玩家账号遭盗用、个人设备问题、网络环境问题、未遵守游戏规章导致账号遭封停等因素，造成无法参与活动、积分损失、奖品无法领取或任何损失，官方概不负责。活动期间若账号遭封停，其未使用之积分及未发放之奖励将自动失效作废。
5. 系统记录为准：所有积分获取、消耗、抽奖记录、中奖记录等，均以官方系统后台记录为最终依据。

※ 《Ragnarok: The New World》官方保留本活动最终解释权，并有权在法律允许范围内，根据实际情况对活动内容、规则及奖励进行调整或补充，相关内容以官方公告为准。`,
  createPopupTip: '本人知悉并同意：您于投稿时即同意授予游戏官方一项全球范围内、永久、不可撤回且免权利金之授权，用于游戏内外及相关营销、宣传、改作及衍生利用。',
  checkTermsTip: '请勾选授权条款同意项',
  imageUploadingTip: '图片正在上传中，请稍后',
  imageSizeTip: '图片大小不能超过10MB',
  imageFormatTip: '仅支持JPG和PNG格式图片',
  imageMaxTip: '最多只能上传3张图片',
  imageUploadFailTip: '图片上传失败，请重试',
  saveConfirmMessage: '是否保留本次编辑的内容？',
  footerRatingLines: ['本游戏内容涉及暴力、恋爱交友', '本游戏部分内容需另行支付费用', '请避免沉迷游戏'],
  footerTermsText: '服务条款',
  footerPrivacyText: '隐私政策',
  awardThanks: '谢谢参与',
  awardTitle: '定制称号【向企划抛出枯树枝】*1',
  awardAvatar: '定制头像框【共创企划家】*1',
  awardHeadwear: '定制头饰【黑猫耳朵】*1',
  awardBlindbox: '卡普拉盲盒*1',
  awardZeny: '绑定zeny*3000',
  awardCoin: '冒险币*10000',
  awardDoll: '限定玩偶',
  awardCard: '收藏卡牌',
  awardTshirt: 'ROW T恤', // TODO: 确认奖励名称
  awardBackpack: '联名双肩包',
  awardPhotocard: 'BABYMONSTER联名限定小卡（全套）',
  awardPhoneHolder: '巴风特手机支架',
  awardCanvasBag: '大世界帆布包',
  awardFridgeMagnet: '初心者装死冰箱贴',
  awardWaistPillow: 'RO职业书本腰靠',
  scoreTitleNone: '无',
  scoreTitleLv1: '初心者脑洞好大喔',
  scoreTitleLv2: 'RO大世界入股不亏',
  scoreTitleLv3: '不装了我是创世神',
  footerTermsUrl: 'https://www.gnjoy.hk/Terms',
  footerPrivacyUrl: 'https://www.gnjoy.hk/Policies',
};
